import assets from 'modules/assets'
import * as parse from 'modules/parse'

export function intro(data) {
  // Feeds into LargeQuote
  return {
    content: [
      [
        {
          type: 'h3',
          content: ['Gakko New York']
        },
        {
          type: 'p',
          style: 'large',
          content: [data['house-intro-subtitle']]
        }
      ],
      [
        {
          type: 'h2',
          content: [data['house-intro-splash-1']]
        }
      ],
      [
        {
          type: 'p',
          style: 'large',
          content: data['house-intro-splash-2']
        }
      ]
    ]
  }
}

export function values(data) {
  // Feeds into RowThreeText
  return {
    content: [
      [
        {
          type: 'h3',
          content: ['Overview']
        }
      ],
      [
        {
          type: 'p',
          content: data['house-intro-paragraph-1']
        },
        {
          type: 'p',
          content: data['house-intro-paragraph-2']
        }
      ],
      [
        {
          type: 'h5',
          content: ['Key Details']
        },
        {
          type: 'p',
          content: data['house-intro-paragraph-3']
        },
        {
          type: 'h5',
          content: ['Flagship Programs']
        },
        {
          type: 'p',
          content: data['house-intro-paragraph-4']
        }
      ]
    ]
  }
}

export function technology(data) {
  // Feeds into RowThreeText
  return {
    marginTopStyle: 'small',
    content: [
      [
        {
          type: 'h2',
          content: ['Code Forward']
        }
      ],
      [
        {
          type: 'p',
          hasMarginTop: true,
          style: 'large',
          content: data['house-technology-one-liner']
        }
      ],
      [
        {
          type: 'p',
          content: '',
          button: {
            content: 'Learn more to apply',
            linkURL: '/newyork#apply'
          }
        }
      ]
    ]
  }
}

export function technologyDirectorHeader(data) {
  // Feeds into RowThreeText
  return {
    content: [
      [
        {
          type: 'h3',
          content: ['Alex Qin']
        },
        {
          type: 'h3',
          style: 'sectra-light',
          content: ['Director/Lead Teacher']
        }
      ],
      [
        {
          type: 'image',
          src: 'images/house/alex.jpg'
        }
      ]
    ]
  }
}

export function technologyDirectorInfo(data) {
  // Feeds into RowThreeText
  return {
    marginTopStyle: 'small',
    content: [
      [],
      [
        {
          type: 'p',
          hasMarginTop: false,
          content: data['house-technology-director-paragraph-1']
        }
      ],
      [
        {
          type: 'p',
          hasMarginTop: false,
          content: data['house-technology-director-paragraph-2']
        }
      ]
    ]
  }
}

export function technologyTestimonial(data) {
  // Feeds into RowThreeText
  return {
    marginTopStyle: 'small',
    content: [
      [
        {
          type: 'h3',
          style: 'sectra-light',
          content: ['Student Testimonial']
        }
      ],
      [
        {
          type: 'p',
          content: data['house-technology-testimonial-1']
        }
      ],
      [
        {
          type: 'p',

          content: data['house-technology-testimonial-2']
        },
        {
          type: 'h5',
          style: 'sectra-light',
          hasMarginTop: false,
          content: data['house-technology-testimonial-3']
        }
      ]
    ]
  }
}

export function technologyProgramOverview(data) {
  // Feeds into RowThreeText
  return {
    content: [
      [
        {
          type: 'h3',
          style: 'sectra-light',
          content: ['Program Overview']
        }
      ],
      [
        {
          type: 'p',
          content: data['house-technology-program-overview-1']
        },
        {
          type: 'p',
          content: data['house-technology-program-overview-2']
        }
      ],
      [
        {
          type: 'h5',
          style: 'sectra-light',
          content: ['Our students will learn:']
        },
        {
          type: 'p',
          content: data['house-technology-program-overview-3']
        }
      ]
    ]
  }
}

export function technologyTime(data) {
  // Feeds into RowThreeText
  return {
    content: [
      [
        {
          type: 'h3',
          style: 'sectra-light',
          content: ['Program Details']
        }
      ],
      [
        {
          type: 'p',
          content: data['house-technology-program-time']
        }
      ],
      []
    ]
  }
}

export function technologyCollaborators(data) {
  // Feeds into RowThreeText
  return {
    content: [
      [
        {
          type: 'h3',
          style: 'sectra-light',
          content: ['Guest Lecturers']
        }
      ],
      [

        {
          type: 'square-image',
          src: 'images/house/technology-collaborator-ope.jpg'
        },
        {
          type: 'h5',
          style: 'sectra-light',
          content: ['Ope Bukola']
        },
        {
          type: 'p',
          hasMarginTop: false,
          content: ['Product Manager at Google']
        }
      ],
      [
        {
          type: 'square-image',
          src: 'images/house/technology-collaborator-ramsey.png'
        },
        {
          type: 'h5',
          style: 'sectra-light',
          content: ['Ramsey Nasser']
        },
        {
          type: 'p',
          hasMarginTop: false,
          content: ['Professor at NYU ITP, Parsons, the School for Poetic Computation']
        }
      ]
    ]
  }
}

export function music(data) {
  // Feeds into RowThreeText
  return {
    marginTopStyle: 'small',
    content: [
      [
        {
          type: 'h2',
          content: ['[your album here]']
        }
      ],
      [
        {
          type: 'p',
          hasMarginTop: true,
          style: 'large',
          content: data['house-music-one-liner']
        }
      ],
      [
        {
          type: 'p',
          content: '',
          button: {
            content: 'Learn more to apply',
            linkURL: '/newyork#apply'
          }
        }
      ]
    ]
  }
}

export function musicTime(data) {
  // Feeds into RowThreeText
  return {
    content: [
      [
        {
          type: 'h3',
          style: 'sectra-light',
          content: ['Program Details']
        }
      ],
      [
        {
          type: 'p',
          content: data['house-music-program-time']
        }
      ],
      []
    ]
  }
}

export function musicDirectorHeader(data) {
  // Feeds into RowThreeText
  return {
    content: [
      [
        {
          type: 'h3',
          content: ['Graham Banfield']
        },
        {
          type: 'h3',
          style: 'sectra-light',
          content: ['Director/Lead Teacher']
        }
      ],
      [
        {
          type: 'image',
          src: 'images/house/graham.jpg'
        }
      ]
    ]
  }
}

export function musicDirectorInfo(data) {
  // Feeds into RowThreeText
  return {
    marginTopStyle: 'small',
    content: [
      [],
      [
        {
          type: 'p',
          hasMarginTop: false,
          content: data['house-music-director-paragraph-1']
        }
      ],
      [
        {
          type: 'p',
          hasMarginTop: false,
          content: data['house-music-director-paragraph-2']
        }
      ]
    ]
  }
}

export function musicTestimonial(data) {
  // Feeds into RowThreeText
  return {
    marginTopStyle: 'small',
    content: [
      [
        {
          type: 'h3',
          style: 'sectra-light',
          content: ['Student Testimonial']
        }
      ],
      [
        {
          type: 'p',
          content: data['house-music-testimonial-1']
        }
      ],
      [
        {
          type: 'p',
          content: data['house-music-testimonial-2']
        },
        {
          type: 'h5',
          style: 'sectra-light',
          hasMarginTop: false,
          content: data['house-music-testimonial-3']
        }
      ]
    ]
  }
}

export function musicProgramOverview(data) {
  // Feeds into RowThreeText
  return {
    content: [
      [
        {
          type: 'h3',
          style: 'sectra-light',
          content: ['Program Overview']
        }
      ],
      [
        {
          type: 'p',
          content: data['house-music-program-overview-1']
        },
        {
          type: 'p',
          content: data['house-music-program-overview-2']
        }
      ],
      [
        {
          type: 'h5',
          style: 'sectra-light',
          content: ['Our students will:']
        },
        {
          type: 'p',
          content: data['house-music-program-overview-3']
        }
      ]
    ]
  }
}

export function musicCollaborators(data) {
  // Feeds into RowThreeText
  return {
    content: [
      [
        {
          type: 'h3',
          style: 'sectra-light',
          content: ['Guest Lecturers']
        }
      ],
      [

        {
          type: 'square-image',
          src: 'images/house/music-collaborator-invisible.jpeg'
        },
        {
          type: 'h5',
          style: 'sectra-light',
          content: ['Invisible Anatomy'],
          linkURL: 'http://www.invisibleanatomy.com/'
        }
      ],
      [
        {
          type: 'square-image',
          src: 'images/house/music-collaborator-xin.jpg'
        },
        {
          type: 'h5',
          style: 'sectra-light',
          content: ['Xin Wang'],
          linkURL: 'http://www.xinwang.ca/'
        }
      ]
    ]
  }
}


export function admissions(data) {
  // Feeds into RowThreeText
  return {
    marginTopStyle: 'small',
    content: [
      [
        {
          type: 'h3',
          style: 'sectra-light',
          content: ['Inclusivity']
        }
      ],
      [
        {
          type: 'p',
          content: data['house-admissions-1']
        }
      ],
      []
    ]
  }
}

export function tuition(data) {
  // Feeds into RowThreeText
  return {
    marginTopStyle: 'small',
    content: [
      [
        {
          type: 'h3',
          style: 'sectra-light',
          content: ['Tuition & Fees']
        }
      ],
      [
        {
          type: 'h5',
          style: 'sectra-light',
          content: [data['house-tuition-title-1']]
        },
        {
          type: 'p',
          content: [data['house-tuition-1']]
        },
        {
          type: 'h5',
          style: 'sectra-light',
          content: [data['house-tuition-title-2']]
        },
        {
          type: 'p',
          content: [data['house-tuition-2']]
        }
      ],
      [
        {
          type: 'h5',
          style: 'sectra-light',
          content: [data['house-tuition-title-3']]
        },
        {
          type: 'p',
          content: [data['house-tuition-3']]
        }
      ]
    ]
  }
}

export function apply(data) {
  return {
    content: [
      [
        {
          type: 'h3',
          style: 'sectra-light',
          content: ['How to Apply']
        }
      ],
      [
        {
          type: 'p',
          content: [data['house-apply-1']]
        }
      ],
      [
        {
          type: 'p',
          content: [data['house-apply-2']]
        }
      ]
    ]
  }
}

export function applyButtons(data) {
  return {
    content: [
      [],
      [
        {
          type: 'p',
          content: '',
          button: {
            content: 'Join the waitlist!',
            outbound: true,
            linkURL: 'https://docs.google.com/forms/d/e/1FAIpQLSdn_2hG_h8RflkIbgQT_uwCdzBWG78doEltTPCC_kanelAlGw/viewform'
          }
        }
      ],
      [
        {
          type: 'p',
          content: '',
          button: {
            content: 'Nominate a student',
            outbound: true,
            linkURL: 'https://docs.google.com/forms/d/1HD5NK7M1-TLB81ghs9ptGHnNitjRlIzoEePRmaCNVIQ/viewform'
          }
        }
      ]
    ]
  }
}

export function termsAndConditions(data) {
  return {
    content: [
      [],
      [
        {
          type: 'h5',
          style: 'sectra-light',
          content: [data['house-tands-billing-title']]
        },
        {
          type: 'p',
          content: [data['house-tands-billing-1']]
        },
        {
          type: 'p',
          content: [data['house-tands-billing-2']]
        },
        {
          type: 'p',
          content: [data['house-tands-billing-3']]
        }
      ],
      [
        {
          type: 'h5',
          style: 'sectra-light',
          content: [data['house-tands-cancellations-title']]
        },
        {
          type: 'p',
          content: [data['house-tands-cancellations-1']]
        },
        {
          type: 'p',
          content: [data['house-tands-cancellations-2']]
        },
        {
          type: 'p',
          content: [data['house-tands-cancellations-3']]
        }
      ]
    ]
  }
}

export function faq(data) {
  return {
    title: 'FAQ',
    english: '',
    japanese: '',
    definition: '',
    wordType: '',
    definition2: '',
    definition3: '',
    button: '',
    linkURL: '',
    deadline: '',
    questions: [
      {
        question: 'Do I have to live in New York City to participate?',
        answer: 'Gakko New York after school programs all take place in Manhattan at 243 Canal Street. As long as you can get here for class sessions over the course of the 10 week program, you can live anywhere! Unfortunately, we cannot offer any travel or housing support for participants, so if you are applying from outside of the New York area you will need to find travel and and housing independently.'
      },
      {
        question: 'Can I enroll for both technology and music classes at Gakko New York?',
        answer: 'You can! We will want to chat with you to make sure that you can fit in such a considerable time commitment. But we\’d love to have you. Please select both programs in the application form and we\'ll reach out to talk with you more about your interests and time commitment.'
      },
      {
        question: 'Are the "suggested lengths" on the application short answer questions a hard limit?',
        answer: 'Not at all! The suggested lengths shown are just that—suggestions. If you feel that you need more or less space to share who you are and your response to our prompts, please feel free to do so.'
      },
      {
        question: 'After I take your class, how can I stay involved?',
        answer: 'Gakko New York is so much more than a school with two courses. Besides the advanced classes we offer, we host a multitude of events, conferences, summer camps, and parties, as well as volunteer, intern, and teaching assistant opportunities.'
      },
      {
        question: 'I have my own project idea for Gakko New York—can I share it with you?',
        answer: 'Yes, please! Gakko sees itself as an incubator for new approaches to education, art, and technology. If you have an idea, pitch it!'
      },
      {
        question: 'I want to participate but I’m not in High School! What can I do?',
        answer: 'Courses for younger and older students are presently in development, stay tuned!'
      },
      {
        question: 'Will my success l participation in Gakko New York programs help me get into college? Is Gakko New York accredited?',
        answer: 'We are not accredited but we are working hard to develop and further relationships with colleges and universities so that they understand and recognize the benefits of Gakko New York participation.'
      },
      {
        question: 'How will I be evaluated? Are there grades?',
        answer: 'Grades are for grade school! While we don’t assign grades to our students, we take evaluation very seriously, and provide in depth and careful feedback to all of our students.'
      },
      {
        question: 'Can I sponsor a student?',
        answer: 'Yes, you can! If you’d like to make this opportunity available for a student in New York, you are awesome! Please contact us at newyork@gakkoproject.com and we’ll reach out with more information.'
      }
    ]
  }
}

export function questions(data) {
  return {
    content: [
      [
        {
          type: 'h3',
          style: 'sectra-light',
          content: ['Questions']
        }
      ],
      [
        {
          type: 'p',
          style: 'large',
          content: ['Please feel free to reach out for additional information or with any questions not covered here.']
        },
        {
          type: 'h5',
          content: 'newyork@gakkoproject.com',
          mailTo: true,
          linkURL: 'mailto:newyork@gakkoproject.com?Subject=Hello'
        },
        {
          type: 'h5',
          content: '✆ (347) 560-1079'
        }
      ],
      []
    ]
  }
}



// WEBPACK FOOTER //
// ./src/modules/house.js